import './assets/i18n/i18n';
import { ApiErrorProvider } from './providers/ApiErrorProvider';
import { AuthProvider } from './providers/AuthProvider';
import { BrowserCacheLocation, PublicClientApplication } from '@azure/msal-browser';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import App from './pages/App/App';
import React from 'react';
import ReactDOM from 'react-dom/client';

const pca = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: `${process.env.REACT_APP_AZURE_AUTH_DOMAIN}${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: '/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ApiErrorProvider>
      <BrowserRouter>
        <MsalProvider instance={pca}>
          <AuthProvider instance={pca}>
            <App />
          </AuthProvider>
        </MsalProvider>
      </BrowserRouter>
    </ApiErrorProvider>
  </React.StrictMode>
);
